import { PromptTemplateCategory } from '../types';

export const dialogue: PromptTemplateCategory = {
  title: "संवाद",
  icon: "💬",
  templates: [
    {
      title: "पॉडकास्ट साक्षात्कार टेम्पलेट",
      content: `दो वक्ताओं के बीच पॉडकास्ट-शैली का साक्षात्कार लिखें।
- वक्ता 1 होस्ट है: [एक जिज्ञासु और उत्साही टेक पत्रकार]।
- वक्ता 2 अतिथि है: [एक प्रसिद्ध AI शोधकर्ता जिसने अभी-अभी एक क्रांतिकारी शोधपत्र प्रकाशित किया है]।
- चर्चा का विषय है [रचनात्मक क्षेत्रों में मानव-AI सहयोग का भविष्य]।
- लहजा होना चाहिए [संवादात्मक, अंतर्दृष्टिपूर्ण, और कभी-कभी हास्यपूर्ण]।
- फॉलो-अप प्रश्नों और किस्सों के साथ स्वाभाविक बातचीत शामिल करें।

प्रत्येक पंक्ति को "Speaker 1:" या "Speaker 2:" के रूप में लिखें, उसके बाद उनका संवाद।`,
      mode: 'multi'
    },
    {
      title: "बहस टेम्पलेट",
      content: `विपरीत दृष्टिकोण रखने वाले दो वक्ताओं के बीच एक संरचित बहस लिखें।
- वक्ता 1 तर्क देता है [कि रिमोट वर्क स्थायी डिफ़ॉल्ट बनना चाहिए]।
- वक्ता 2 तर्क देता है [कि नवाचार के लिए कार्यालय सहयोग आवश्यक है]।
- दोनों वक्ताओं को [वास्तविक दुनिया के उदाहरणों के साथ अच्छी तरह से तर्कसंगत बिंदु] प्रस्तुत करने चाहिए।
- लहजा होना चाहिए [सम्मानजनक लेकिन जोशीला]।
- प्रत्येक वक्ता को दूसरे के बिंदुओं का सीधे जवाब देना चाहिए।

प्रत्येक पंक्ति को "Speaker 1:" या "Speaker 2:" के रूप में लिखें, उसके बाद उनका संवाद।`,
      mode: 'multi'
    },
    {
      title: "भाषा सीखने का संवाद टेम्पलेट",
      content: `भाषा सीखने वालों के लिए दो वक्ताओं के बीच एक बातचीत संवाद लिखें।
- परिदृश्य है [एक व्यस्त स्ट्रीट मार्केट में खाना ऑर्डर करना]।
- वक्ता 1 है [एक मिलनसार स्थानीय विक्रेता जो अपने सबसे अच्छे व्यंजनों की सिफारिश कर रहा है]।
- वक्ता 2 है [एक यात्री जो पहली बार स्थानीय व्यंजन आज़मा रहा है]।
- शामिल करें [स्वाभाविक झिझक, विनम्र वाक्यांश, और सांस्कृतिक संदर्भ]।
- संवाद प्रामाणिक लगना चाहिए और सीखने वालों को [रोज़मर्रा की बातचीत के वाक्यांशों] में मदद करना चाहिए।

प्रत्येक पंक्ति को "Speaker 1:" या "Speaker 2:" के रूप में लिखें, उसके बाद उनका संवाद।`,
      mode: 'multi'
    }
  ]
};
